<template>
  <div id="bulkUploadPopup" class="modal fade" role="dialog">
    <div class="modal-dialog profile-confirm-poup">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header confirmpopup-bgcolor p-0">
          <div class="add-record-title">
            <div>{{ $t('bulkUpload') }}</div>
            <div @click="closeModal()" class="close-icon cursor-pointer">
              <img src="/static/images/icons/ul_close_icon.svg" class="address-images" />
            </div>
          </div>
        </div>
        <div class="modal-body confirm-body ">
          <div v-if="!isUpload" class="proceed-title">
            <div  class="download-text">
              <span>{{$t('downloadTemplate')}}</span>
          </div>
          <div>
             <button type="button" class="btn download-button" @click="downloadTemplate()" >
              <img src="/static/images/icons/DownloadTemplate.svg" class="pr-4 pb-3" />
            <span class="seeMore pr-8">{{ $t('downloadTemplateLabel') }}</span>
          </button>
          </div>
          <hr class="upper-line" />
          <div class="">
                <div @drop.prevent.stop="getDroppedFile" @dragover.prevent.stop="onDragOver"
                class="upload-area">
                   <div class="mt-24 ml-16">
                          <ul  class="instructions">
                              <li class="">{{ $t('uploadInstructions1')}}</li>
                              <li> {{ $t('uploadInstructions2')}}</li>
                              <li>{{ $t('uploadInstructions3')}}</li>
                              <li>{{ $t('uploadInstructions4')}}</li>
                              <li>{{ $t('uploadInstructions5')}}</li>
                          </ul>
                          <input type="file" ref="bulkUploadFile" id="bulkUpload" class="hidden" @change="setSelectedFile"/>
                          <button for="bulkUpload" class="btn btn-block blue_outline_upload_button" @click="openFileUpload">{{$t('upload')}}
                          </button>
                      </div>
                <div class="selected d-flex ptl-32" v-if="fileName" :title="fileName">
                  <div class="word-break file-name">{{  fileName }}</div>
                  <img class="cursor-pointer delete-icon" src="/static/images/icons/Headlines_Delete_icon.svg" @click="clearSelectedFile"/>
                </div>
              </div>
          </div>
          </div>
          <div v-else class="center mb-179 mt-179">
              <img src="/static/images/icons/uploadLoader.svg" class="address-images" />
              <div class="mt-37">{{$t('recordStatus')}}</div>
          </div>
        </div>

        <div class="modal-footer confirmpopup-bgcolor col-xs-12 col-sm-12 d-flex-sm-end">
          <div  class="">
            <button type="button" class="btn emergo-btn emergo-secondary-button" @click="closeModal">{{ $t('cancel') }}</button>
          </div>

          <div  class="">
            <button type="button" class="btn emergo-btn emergo-primary-button" :disabled="!fileName || isUpload" @click="save">{{ $t('save') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import FileSaver from 'file-saver';
import { downloadTemplate, uploadTemplete } from '../../apis/BulkUpload';
import b64toBlob from '../../utils/base64toBlob';

export default {
  data() {
    return {
      uploadFieldName: 'file',
      uploadedFiles: [],
      acceptedExtensions: ['.xlsx'],
      isUpload: false,
      fileName: '',
      errorText: '',
      isNotConaints: ''
    };
  },
  methods: {
    async downloadTemplate() {
      const response = await downloadTemplate();
      const blob = b64toBlob(
        response.content,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      );
      FileSaver.saveAs(blob, 'Template.xlsx');
    },
    closeModal() {
      this.clearSelectedFile();
      $('#bulkUploadPopup').modal('hide');
    },
    async save() {
      this.isUpload = true;
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      const response = await uploadTemplete(formData);
      this.isUpload = false;
      this.selectedFile = null;
      this.fileName = '';
      $('#bulkUploadPopup').modal('hide');
      if (response && response.error_records) {
        this.$emit('uploadRecords', response, 'invalid');
      } else if (response && response.message) {
        this.$emit('uploadRecords', response, 'error');
      } else {
        this.$emit('uploadRecords', response, 'success');
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'Portuguese' ? 'Certificados carregados' : 'Certificates were uploaded',
          group: 'custom-notification',
        });
      }
    },
    openFileUpload() {
      $('#bulkUpload').click();
    },
    setSelectedFile() {
      const [selectedFile] = this.$refs.bulkUploadFile.files;
      if (!selectedFile) return;
      const isAnyErrorExists = this.validateFileType(selectedFile);
      if (isAnyErrorExists) return;
      this.checkImageDimension(selectedFile);
    },
    validateFileType(fileDetails) {
      const fileExtension = fileDetails.name.split('.').pop();
      if (!['xlsx'].includes(fileExtension)) {
        this.errorText = true;
        this.setFileDetails({
          file: null,
          fileName: '',
        });
        this.$refs.bulkUploadFile.value = '';
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Tipo de arquivo xlsx permitido' : 'File type xlsx allowed',
          group: 'custom-notification',
        });
      } else {
        this.errorText = '';
      }
      return this.errorText;
    },
    onDragOver(event) {
      event.dataTransfer.dropEffect = 'copy';
    },

    getDroppedFile(event) {
      if ([...event.dataTransfer.files].length === 1) {
        const [selectedFile] = [...event.dataTransfer.files];
        const isAnyErrorExists = this.validateFileType(selectedFile);
        if (isAnyErrorExists) return;
        this.checkImageDimension(selectedFile);
      } else if ([...event.dataTransfer.files].length > 1) {
        this.$refs.bulkUploadFile.value = '';
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Apenas um excel permitido' : 'Only one excel allowed',
          group: 'custom-notification',
        });
      }
    },
    setFileDetails({
      file, fileName
    }) {
      this.selectedFile = file;
      this.fileName = fileName;
    },
    checkImageDimension(selectedFile) {
      if (Math.round(selectedFile.size / 1024) < 20 * 1024 * 1024) {
        this.setFileDetails({
          file: selectedFile,
          fileName: selectedFile.name
        });
      } else {
        this.setFileDetails({
          file: null,
          fileName: '',
        });
        this.$refs.bulkUploadFile.value = '';
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'O tamanho do arquivo não pode exceder 20 MB' : 'File size cannot exceed 20MB',
          group: 'custom-notification',
        });
      }
    },
    clearSelectedFile() {
      this.$refs.bulkUploadFile.value = '';
      this.selectedFile = null;
      this.fileName = '';
      this.errorText = '';
    },
  },
};
</script>

<style scoped>
.blue_outline_upload_button,
.blue_outline_upload_button:hover,
.blue_outline_upload_button:focus{
  background-color: #E6E6E6;
  height: 34px;
  max-width: 95px;
  color: #404040;
  font-size: 16px;
  font-weight: 600;
  border-radius: 3px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin:26px 0px 0px 23px
}
.upload-area {
  min-height: 318px;
  border-radius: 3px;
  border: 1px solid #d3d3d3;
}
.pr-4 {
  padding-right: 4px;
}
ul {
  margin: 0px !important;
  padding-left:22px;
  text-align: left;
}
.ptl-32 {
  padding-top:32px;
  padding-left: 38px ;
}
.mt-24 {
  margin-top:24px;
}
.mt-16 {
  margin-top:19px;
}
.delete-icon{
  width:18px;
  height: 18px;
}
.file-name{
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #01518A;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
  padding-right:8px;
}
.download-button {
  background: none;
  color: #01518A !important;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 400;
  padding: 0px !important;
  vertical-align: unset;
  margin-left:7px;
}
.emergo-btn {
  padding: 6px 16px !important;
  line-height: 22px !important;
}
.upper-line{
  border-top:1px solid #d3d3d3 !important;
  margin: 32px 6px 26px 0px;
}
.instructions {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #333333;
}
.download-text {
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #3E3E3E;
    padding-bottom: 22px;
}
label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 0px !important;
    /* font-weight: 700; */
}
.modal-header {
    background-color: #ffffff !important;
    border-bottom: 1px solid #d3d3d3 !important;
    border-top-right-radius: 6px!important;
    border-top-left-radius: 6px!important;
}

.modal-header .close {
    background: unset;
    opacity: 1;
    line-height: unset;
    width: unset;
    border-radius: unset;
    color: unset;
    background-color: #ffffff !important;
}

.add-record-title {
    display: flex;
    justify-content: space-between;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    color: #1a1a1a;
    padding: 12px 0px 11px 16px;
}
.close-icon {
    padding-right: 20px;
}

.proceed-title {
    font-weight: 600;

    font-size: 16px;

    line-height: 22px;

    color: #000001;
}

.modal-body {
    padding: 33px 31px 16px 32px;
}

.modal-footer {
    background-color: #fafaf9 !important;
    padding-right: 0px;
    border: none !important;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
}
.modal-content {
 border: none;
 border-top-right-radius: 6px!important;
 border-top-left-radius: 6px!important;
 border-bottom-right-radius: 0!important;
 border-bottom-left-radius: 0!important;
}
.pb-21 {
 padding-bottom: 21px;
}
.mt-37 {
  margin-top:37px;
}
.mb-179 {
  margin-bottom:179px;
}
.mt-179 {
  margin-top:179px;
}
::v-deep .el-upload-dragger.is-dragover {
  border: none;
  background-color: transparent;
}

::v-deep .el-upload-dragger {
  height: 318px;
  width: 100%;
}
::v-deep .el-upload-dragger, .el-upload-dragger:hover {
  border: none;
  border-color: #fff;
}
::v-deep .el-upload-list__item.is-ready .el-icon-close {
  display: inline-block;
  left: 75%;
  top: 4px;
  opacity: 1;
  font-weight: bolder !important;
}
::v-deep .el-upload-list__item.is-success .el-icon-close {
  display: inline-block;
  left: 80%;
  top: 9px;
  opacity: 1;
  font-weight: bolder !important;
}
::v-deep .el-upload-list__item.is-ready {
  max-width: 500px;
  margin: 0px auto 10px auto;
}
::v-deep .el-upload-list__item:hover {
  background-color: transparent !important;
}
::v-deep .el-icon-close:before {
  content: url('/static/images/icons/emergo_delete.svg');
}
::v-deep .el-icon-document:before {
  content: none !important;
}
/* ::v-deep .el-upload-list__item:first-child{
  margin-top: 32px;
} */
.upload-demo ::v-deep .el-upload-list__item-name {
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  color: #01518A;
  white-space: nowrap;
  overflow: hidden;
  margin: auto auto 10px auto;
  /* max-width: 70%; */
  margin-top: 0px;
}
.upload-demo {
  border: 1px solid #d3d3d3;
  margin-right: 4px;
  border-radius: 3px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-name {
  color: #333333;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  margin: auto;
}
::v-deep .el-upload-list__item.is-success {
  background-color: transparent !important;
  max-width: 500px;
  margin: 10px auto auto auto;
}

::v-deep .el-upload-list {
  display: none;
}
::v-deep .el-upload-list__item.is-success:hover,
::v-deep .el-upload-list__item.is-success .el-upload-list__item-name:hover {
  color: #333333;
  cursor: pointer;
}
::v-deep .upload-demo input[type='file'] {
  display: none;
}

@media (min-width: 768px) {
.modal-dialog {
 width: 747px;
 margin: 30px auto;
 /* height: 640px; */
}
}
</style>
